export const requests = '/consultation-requests';
export const getRequestById = (id: string) => `/consultation-requests/${id}`;
export const deleteRequest = (id: number) => `/consultation-requests/${id}`;
export const download = 'consultation-requests/download';
